import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { RootState } from '../../redux/store';
import {
  useForm,
  // Controller
} from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import 'yup-phone';
import * as yup from 'yup';
import { useDispatch } from 'react-redux';

import Button from '../../styled/Button';
import Text from '../../styled/Text';
import Spacer from '../../styled/Spacer';
import {
  LoginLeftSideBox,
  LoginRightSideBox,
  ModalHeader,
} from './LoginPopup.styled';
import { signUp } from '../../redux/loggedInUser/loggedInUser.actions';
import {
  getDeviceDetails,
  getIpAddress,
  getPageURL,
  getUserAgent,
} from '../../utils/deviceInfoService';
import selectCountry from './../../utils/selectCountry';
import ReactFlagsSelect from 'react-flags-select';
import { getLocation } from '../../utils/getLocation';
import useResponsiveDevice from '../useResponsiveDevice';

interface SignupBoxProps {
  setTab: Function;
  handleClose: Function;
}

const SignupBox: FC<SignupBoxProps> = ({ setTab, handleClose }) => {
  const router = useRouter();
  const geolocation = useSelector(
    (store: RootState) => store.location.geolocation,
  );
  const [code, setCode] = useState<string>(geolocation == 'in' ? '91' : '1');
  const [country, setCountry] = useState<string>(
    geolocation == 'in' ? 'IN' : 'US',
  );
  const setCountryCode = (code: string) => {
    let country = selectCountry(code);
    setCode(country);
    setCountry(code);
  };
  let signupSchema =
    country == 'IN'
      ? yup.object().shape({
          type: yup.string().required(),
          name: yup.string().required('Full Name is required'),
          email: yup.string().email().required('Email is required'),
          mobile: yup
            .string()
            .phone()
            .test('len', (val: string | undefined, { createError, path }) =>
              val?.length === 10
                ? true
                : createError({
                    path,
                    message: 'Phone number should be valid and 10 digits long',
                  }),
            )
            .required(),
          company: yup.string().when('type', {
            is: 'Business',
            then: yup.string().required(),
            otherwise: yup.string(),
          }),
          gst: yup.string().when('type', {
            is: 'Business',
            then: yup.string().required(),
            otherwise: yup.string(),
          }),
        })
      : yup.object().shape({
          type: yup.string().required(),
          name: yup.string().required('Full Name is required'),
          email: yup.string().email().required('Email is required'),
          mobile: yup.string().required(),
          company: yup.string().when('type', {
            is: 'Business',
            then: yup.string().required(),
            otherwise: yup.string(),
          }),
          gst: yup.string().when('type', {
            is: 'Business',
            then: yup.string().required(),
            otherwise: yup.string(),
          }),
        });
  const {
    register,
    unregister,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(signupSchema),
    defaultValues: {
      name: '',
      type: 'INDIVIDUAL',
      email: '',
      mobile: '',
      company: '',
      gst: '',
    },
  });

  const watchedType = watch('type');

  const dispatch: any = useDispatch();

  useEffect(() => {
    if (watchedType === 'INDIVIDUAL') {
      unregister(['company', 'gst']);
    }
  }, [watchedType]);

  const [deviceDetails, setDeviceDetails] = useState<any>({});
  const { isMobile } = useResponsiveDevice();
  useEffect(() => {
    const getDetails = async () => {
      const ip = await getLocation();
      // const device = await getDeviceDetails();
      const result = {
        device: '',
        device_type: isMobile ? 'Mobile' : 'Desktop',
        ip_address: ip ? ip : '',
        path: getPageURL(),
        userAgent: getUserAgent(),
      };
      setDeviceDetails({ ...result });
    };
    getDetails();
  }, []);
  useEffect(() => {
    signupSchema =
      country == 'in'
        ? yup.object().shape({
            type: yup.string().required(),
            name: yup.string().required('Full Name is required'),
            email: yup.string().email().required('Email is required'),
            mobile: yup
              .string()
              .phone()
              .test('len', (val: string | undefined, { createError, path }) =>
                val?.length === 10
                  ? true
                  : createError({
                      path,
                      message:
                        'Phone number should be valid and 10 digits long',
                    }),
              )
              .required(),
            company: yup.string().when('type', {
              is: 'Business',
              then: yup.string().required(),
              otherwise: yup.string(),
            }),
            gst: yup.string().when('type', {
              is: 'Business',
              then: yup.string().required(),
              otherwise: yup.string(),
            }),
          })
        : yup.object().shape({
            type: yup.string().required(),
            name: yup.string().required('Full Name is required'),
            email: yup.string().email().required('Email is required'),
            mobile: yup.string().required(),
            company: yup.string().when('type', {
              is: 'Business',
              then: yup.string().required(),
              otherwise: yup.string(),
            }),
            gst: yup.string().when('type', {
              is: 'Business',
              then: yup.string().required(),
              otherwise: yup.string(),
            }),
          });
  }, [country]);
  const onSubmit = (data: any) => {
    data.countryCode = code;
    const signUpData = {
      ...data,
      countryCode: code,
      country: geolocation,
      user_ip_address: deviceDetails?.ip_address?.query,
      user_agent: deviceDetails?.userAgent,
      page_url: deviceDetails?.path,
      device_type: deviceDetails?.device_type,
      source: 'SIGN_UP_BOX',
    };
    dispatch(
      signUp(signUpData, () => {
        handleClose();
        let url = window.location.href;
        if (url.includes('aii')) {
          router.push('/profile');
        }
      }),
    );
  };

  return (
    <div className="row">
      <div className="col-0 col-md-5 p-0 d-flex">
        <LoginLeftSideBox backgroundColor="primary">
          <Text
            color="white"
            fontSize="xxxl"
            fontFamily="montserrat"
            weight="bold"
          >
            Create an Account
          </Text>
          <Text color="white" fontSize="lg">
            You can track all services at <br /> one place
          </Text>
        </LoginLeftSideBox>
      </div>
      <div className="col-12 col-md-7 p-0">
        <ModalHeader closeButton backgroundColor="white" color={'primary'} />
        <LoginRightSideBox>
          <div>
            <form onSubmit={handleSubmit(onSubmit)} className="registerForm">
              <Text fontSize="lg" color="gray" weight="midbold">
                Create an Account
              </Text>
              <Spacer direction="vertical" size={20} />
              <Text fontSize="md" weight="semibold" color="label">
                Your Name
              </Text>
              <input
                className="form-control"
                data-clarity-unmask="True"
                placeholder="Enter your Full name"
                {...register('name')}
              />
              {errors.name && (
                <Text color="red" fontSize="xs">
                  {errors.name?.message}
                </Text>
              )}
              <Spacer direction="vertical" size={20} />
              <Text fontSize="md" weight="semibold" color="label">
                Email Address
              </Text>
              <input
                className="form-control"
                data-clarity-unmask="True"
                placeholder="Enter your Email Address"
                {...register('email')}
              />
              {errors.email && (
                <Text color="red" fontSize="xs">
                  {errors.email?.message}
                </Text>
              )}
              <Spacer direction="vertical" size={20} />
              <Text fontSize="md" weight="semibold" color="label">
                Mobile No.
              </Text>
              <div className="d-flex w-100">
                <div>
                  <ReactFlagsSelect
                    selected={country}
                    onSelect={code => {
                      setCountryCode(code);
                    }}
                    countries={[
                      'IN',
                      'US',
                      'GB',
                      'CA',
                      'ZA',
                      'AU',
                      'SG',
                      'MY',
                      'AE',
                      'SA',
                    ]}
                    optionsSize={14}
                    customLabels={{
                      IN: '+91',
                      US: '+1',
                      GB: '+44',
                      CA: '+1',
                      ZA: '+27',
                      AU: '+61',
                      SG: '+65',
                      MY: '+60',
                      AE: '+971',
                      SA: '+966',
                    }}
                  />
                </div>
                <Spacer direction="horizontal" size={10} />
                <div className="w-100">
                  <input
                    className="form-control"
                    data-clarity-unmask="True"
                    placeholder="Enter valid mobile no."
                    {...register('mobile')}
                  />
                </div>
              </div>
              {errors.mobile ? (
                <Text color="red" fontSize="xs">
                  Invalid mobile number
                </Text>
              ) : (
                <Text fontSize="xs">Enter a valid phone number</Text>
              )}
              {watchedType === 'COMPANY' ? (
                <>
                  <Spacer direction="vertical" size={20} />
                  <Text fontSize="sm" color="label">
                    Company Name
                  </Text>
                  <input
                    className="form-control"
                    data-clarity-unmask="True"
                    placeholder="Enter your Company Name"
                    {...register('company')}
                  />
                  {errors.company && (
                    <Text color="red" fontSize="xs">
                      {errors.company?.message}
                    </Text>
                  )}
                  <Spacer direction="vertical" size={20} />
                  <Text fontSize="sm" color="label">
                    GST Number
                  </Text>
                  <input
                    className="form-control"
                    data-clarity-unmask="True"
                    placeholder="Companies GST number"
                    {...register('gst')}
                  />
                  {errors.gst && (
                    <Text color="red" fontSize="xs">
                      {errors.gst?.message}
                    </Text>
                  )}
                </>
              ) : null}
              <Spacer direction="vertical" size={20} />
              <Button
                size="md"
                block
                rounded
                color="white"
                backgroundColor="primary"
              >
                Create Account
              </Button>
              <Spacer direction="vertical" size={60} />
              <Text center fontSize="md" color="gray" className="bottomLink">
                Already a User?
                <Text
                  as="button"
                  fontSize="md"
                  inline
                  color="primary"
                  style={{
                    background: 'transparent',
                    border: 'unset',
                  }}
                  onClick={() => setTab('LOGIN')}
                >
                  Login here
                </Text>
              </Text>
            </form>
          </div>
        </LoginRightSideBox>
      </div>
    </div>
  );
};

export default SignupBox;
